<ng-container *ngIf="productId(); else noProductId">
    <!-- Class on wrapper: PrimeNG 20 overwrites host [class] on p-tabs. -->
    <div [class]="isFillHeightListTabActive() ? listPageTabsClass : ''">
    <p-tabs
        #tabs
        [value]="activeTabValue()"
        (valueChange)="onActiveTabChange($event)"
    >
        <p-tablist>
            <p-tab value="0">{{ 'common.overview' | translate }}</p-tab>
            <p-tab value="1" #tabDispositionOverview>{{
                'products.disposition-overview' | translate
            }}</p-tab>
            <p-tab value="2" #tabMinimumTargetStockList>{{ 'common.settings' | translate }}</p-tab>
            <p-tab value="3" #tabTimeLine>{{
                'product.storage-history-timeline' | translate
            }}</p-tab>
            <p-tab value="4" #tabLineChart>{{ 'product.stock-line-chart' | translate }}</p-tab>
            <p-tab value="5" #tabWarehouseDisposition>{{
                'warehouse.disposition._' | translate
            }}</p-tab>
            <p-tab value="6" #tabManualStockTransaction>{{
                'warehouse.manual-stock-transaction' | translate
            }}</p-tab>
        </p-tablist>

        <p-tabpanels>
            <p-tabpanel value="0">
                <div class="m-1">
                    <app-storage-place-dropdown
                        placeholder="{{ 'warehouse.all-storage-places' | translate }}"
                        [showAllOption]="true"
                        [selectedId]="storagePlaceIdFilter()"
                        (selectedIdChange)="warehouseChanged($event)"
                        [multiple]="false"
                    ></app-storage-place-dropdown>
                </div>

                <div class="px-1 py-4 md:px-4 lg:px-8">
                    <div class="flex flex-wrap justify-center gap-4">
                        @for (c of cards(); track c.title) {
                            <app-phx-stat-card
                                class="w-[17rem]"
                                [label]="c.title"
                                [value]="c.value"
                                [color]="c.color"
                                [icon]="c.icon"
                                [tooltip]="c.tooltip"
                                [clickable]="!!c.onClick"
                                (cardClick)="c.onClick?.()"
                            />
                        }
                    </div>
                </div>

                <app-product-stock-chart-diagram
                    [productId]="productId()"
                    [storagePlaceId]="storagePlaceIdFilter()"
                ></app-product-stock-chart-diagram>
            </p-tabpanel>

            <p-tabpanel value="1">
                <app-product-disposition-overview-panel
                    *ngIf="tabDispositionOverview.value() == tabs.value()"
                    [productId]="productId()!"
                />
            </p-tabpanel>

            <p-tabpanel value="2">
                <app-product-storage-settings
                    *ngIf="tabMinimumTargetStockList.value() == tabs.value()"
                    [productId]="productId()"
                    [dispositionType]="model?.dispositionType"
                    (dispositionTypeChange)="onDispositionTypeChange($event)"
                />
            </p-tabpanel>

            <p-tabpanel value="3">
                <app-widget-product-storage-timeline
                    *ngIf="tabTimeLine.value() == tabs.value()"
                    [productId]="productId()"
                ></app-widget-product-storage-timeline>
            </p-tabpanel>

            <p-tabpanel value="4">
                <app-product-stock-line-chart
                    *ngIf="tabLineChart.value() == tabs.value()"
                    [productIdInputSig]="productId()"
                    [product]="product()"
                ></app-product-stock-line-chart>
            </p-tabpanel>

            <p-tabpanel value="5">
                <app-widget-warehouse-disposition-workspace
                    *ngIf="tabWarehouseDisposition.value() == tabs.value()"
                    [fixedProductId]="productId()"
                />
            </p-tabpanel>

            <p-tabpanel value="6">
                <app-widget-manual-stock-transaction
                    *ngIf="tabManualStockTransaction.value() == tabs.value()"
                    [fixedProduct]="product()"
                />
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
    </div>
</ng-container>

<ng-template #noProductId> no product id </ng-template>
